import { MaybeLine } from '../../domain/facades/FacadeSpecification';

export const getPerimeter = (lines: MaybeLine[]): number => {
  const lineDistances = [...lines.map((line) => line.distance || 0)]; // 0 if distance === null
  return lineDistances.reduce((p, c) => p + c, 0);
};
